import gql from 'graphql-tag'

export const GET_PRODUCT_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $search: String
    $showInShop: Boolean = true
    $currency: String
  ) {
    getProductPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $search
        showInShop: $showInShop
        currency: $currency
      }
    ) {
      hasMore
      total
      items {
        id
        titleEn
        titleRu
        titleKg
        prices {
          price
          overprice
          wholesalePrice
          currencyObj {
            symbol
            title
          }
        }
        coverImage
        showInShop
        status
        quantity
        tag
        discount
      }
    }
  }
`;

export const GET_PRODUCT_IMAGES_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getProduct (
      data: {
        id: $id
        linkOtherImages: true
      }
    ) {
      id
      coverImage
      images
    }
  }
`

export const GET_PRODUCT_WITH_EXTRA_DATA_QUERY = gql`
  query (
    $id: Int!,
  ) {
    getProduct (
      data: {
        id: $id
      }
    ) {
      id
      alt
      brandId
      categoryId
      subcategoryId
      coverImage
      descriptionEn
      descriptionKg
      descriptionRu
      descriptionShortEn
      descriptionShortKg
      descriptionShortRu
      discount
      homeBanner
      prices {
        currency
        price
        overprice
        wholesalePrice
      }
      quantity
      showInShop
      status
      tag
      titleEn
      titleKg
      titleRu
      keywordsEn
      keywordsKg
      keywordsRu
    }
    getAllProductBrands {
      id
      titleEn
      titleRu
      titleKg
    }
    getAllProductCategories {
      id
      titleEn
      titleRu
      titleKg
    }
    getAllCurrencies {
      title
      symbol
      left
    }
    getAllProductSubcategories {
      id
      titleEn
      titleRu
      titleKg
			category {
				titleEn
				titleKg
				titleRu
			}
    }
  }
`

export const GET_PRODUCT_EXTRA_DATA_QUERY = gql`
  query {
    getAllProductBrands {
      id
      titleEn
      titleRu
      titleKg
    }
    getAllProductCategories {
      id
      titleEn
      titleRu
      titleKg
    }
    getAllCurrencies {
      title
      symbol
      left
    }
    getAllProductSubcategories {
      id
      titleEn
      titleRu
      titleKg
			category {
				titleEn
				titleKg
				titleRu
			}
    }
  }
`
